<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 12 17" fill="none">
    <g clip-path="url(#clip0_23880_3242)">
      <path d="M3.03312 16.2976C4.50512 16.2976 5.69979 15.1029 5.69979 13.6309V10.9643H3.03312C1.56112 10.9643 0.366455 12.1589 0.366455 13.6309C0.366455 15.1029 1.56112 16.2976 3.03312 16.2976Z" 
      fill="#0ACF83"/>
      <path d="M0.366455 8.29761C0.366455 6.82561 1.56112 5.63094 3.03312 5.63094H5.69979V10.9643H3.03312C1.56112 10.9643 0.366455 9.76961 0.366455 8.29761Z" 
      fill="#A259FF"/>
      <path d="M0.366211 2.96427C0.366211 1.49227 1.56088 0.297607 3.03288 0.297607H5.69954V5.63094H3.03288C1.56088 5.63094 0.366211 4.43627 0.366211 2.96427Z" 
      fill="#F24E1E"/>
      <path d="M5.69971 0.297607H8.36637C9.83837 0.297607 11.033 1.49227 11.033 2.96427C11.033 4.43627 9.83837 5.63094 8.36637 5.63094H5.69971V0.297607Z" 
      fill="#FF7262"/>
      <path d="M11.033 8.29761C11.033 9.76961 9.83837 10.9643 8.36637 10.9643C6.89437 10.9643 5.69971 9.76961 5.69971 8.29761C5.69971 6.82561 6.89437 5.63094 8.36637 5.63094C9.83837 5.63094 11.033 6.82561 11.033 8.29761Z" 
      fill="#1ABCFE"/>
    </g>
    <defs>
      <clipPath id="clip0_23880_3242">
        <rect width="10.6667" height="16" fill="white" transform="translate(0.366211 0.297607)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'FigmaIcon',
  props: {
    width: {
      type: Number,
      default: 12,
    },
    height: {
      type: Number,
      default: 17,
    }
  }
}
</script>

<style scoped></style>